<template>
  <div id="AqtIndex">
    <div class="left" :style="{width:$route.path=='/aqt'?'40%':'0'}">
      <img v-if="$route.path=='/aqt'" src="@/assets/images/pulic_2.png">
    </div>
    <div class="right" :style="{width:$route.path=='/aqt'?'60%':'100%'}">
      <SearchIndex ref="child" :style="{width:$route.path=='/aqt'?'100%':'auto'}"></SearchIndex>
    </div>
<!--    <div class="specialcolumn"></div>-->
<!--    <div class="specialcolumn">-->
<!--      <div :style="{color:item.color,border:item.bgimg?'':'1px solid'+item.bordercolor,background:item.bgcolor,backgroundImage:item.bgimg?'url('+item.bgimg+')':''}"-->
<!--           @click="getList(item)"-->
<!--           v-for="(item,index) in columnList" :key="index" class="column_list aqt_lang_mn titlefont">-->
<!--        {{ item.titlelang.mn }}-->
<!--      </div>-->
<!--      <div class="column_list_img">-->
<!--        <img :src='require("../../../assets/images/wlmuq.png")'>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import getCurrentCityName from "@/getCurrentCityName";

const os = require('os'); //提供本地的相关信息
export default {
  components: {
    SearchIndex: (re) => require(["@/views/SearchIndex/MN/Index.vue"], re),
  },
  data() {
    return {
      columnList: [
        {
          titlelang: {
            mn: this.$t('m.Red_Literature'),
            zh: '红色文献'
          },
          color: '#D16E05',
          bgcolor: '#F8BE7F',
          bordercolor: '#D16E05',
          path: '/BooksList',
          type: 'red_literature',
          resourceclass_id: '330',
          typeClass: 1,
          qActive: 24,
          searchContent: JSON.stringify('ᠨᠠᠮ ᠬᠤᠪᠢᠰᠬᠠᠯ ᠤᠨ ᠨᠣᠮ ᠤᠨ ᠲᠠᠶᠢᠯᠤᠮᠵᠢ')
          // searchContent: JSON.stringify('红色文献')
        },
        {
          titlelang: {
            mn: this.$t('m.Children_songs'),
            zh: '儿童民歌'
          },
          color: '#498B2C',
          bgcolor: '#C5F4B3',
          bordercolor: '#488A2C',
          path: '/ChildrenSongList',
          type: 'children_songs',
          resourceclass_id: '',
          typeClass: 1,
          qActive: '',
          searchContent: ''
        },
        {
          titlelang: {
            mn: this.$t('m.allperiodical_copy'),
            zh: '全部期刊'
          },
          color: '#0047BE',
          bgcolor: '#BCEBFF',
          bordercolor: '#0047BE',
          path: '/AllJournalList',
          type: '',
          resourceclass_id: '',
          typeClass: 5,
          qActive: 26,
          searchContent: ''
        },
        {
          titlelang: {
            mn: this.$t('m.wlmq'),
            zh: '乌兰牧骑'
          },
          color: '#f19149',
          bgcolor: '',
          bordercolor: '',
          path: '',
          type: '',
          resourceclass_id: '',
          typeClass: 5,
          qActive: 26,
          searchContent: '',
          bgimg:require("../../../assets/images/wlmuq.png"),
        },
        {
          titlelang: {
            mn: this.$t('m.literature'),
            zh: '文史资料'
          },
          color: '#C35C63',
          bgcolor: '',
          bordercolor: '#C35C63',
          path: '/BooksList',
          type: '',
          culture_id: 287,
          typeClass: 1,
          qActive: 24,
          searchContent: JSON.stringify('ᠰᠣᠶᠣᠯ ᠲᠡᠦᠬᠡ ᠶᠢᠨ ᠮᠠᠲ᠋ᠧᠷᠢᠶᠠᠯ')
        },
        {
          titlelang: {
            mn: this.$t('m.sularong_video'),
            zh: '拉苏荣视频专题'
          },
          color: '#926957',
          bgcolor: '',
          bordercolor: '#926957',
          path: '/VideoFrequencyList',
          type: null,
          culture_id: null,
          typeClass: null,
          qActive: null,
          searchContent: null,
          pid:105
        },
        {
          titlelang: {
            mn: this.$t('m.btjrg_video'),
            zh: '巴图吉日嘎拉马头琴教学'
          },
          color: '#3c5d55',
          bgcolor: '',
          bordercolor: '#3c5d55',
          path: '/VideoFrequencyList',
          type: null,
          culture_id: null,
          typeClass: null,
          qActive: null,
          searchContent: null,
          pid:103
        },
      ],
      classs: false,
    }
  },
  created() {
    this.$store.dispatch('getZtclass').then(() => {})
  },
  methods: {
    //进入专栏列表
    getList(item) {
      let that = this
      if(item.path){
        that.saveUserBehavior(0,('点击'+(item.titlelang.zh||item.titlelang.mn)+'专题按钮'),0)
        that.$router.push({
          path: item.path,
          query: {
            lib_type:sessionStorage.getItem('gcm'),
            typeClass: item.typeClass?that.$crypto.set(item.typeClass):'',
            qActive: item.qActive?that.$crypto.set(item.qActive):'',
            searchContent: item.searchContent?that.$crypto.set(item.searchContent):'',
            title_left: '',
            untype: '',
            press_id: '',
            culture_id: item.culture_id?that.$crypto.set(item.culture_id):'',
            resourceclass_id: item.resourceclass_id?that.$crypto.set(item.resourceclass_id):'',
            pid:item.pid?that.$crypto.set(item.pid):''

          }
        })
      }

    },
    saveUserBehavior(type, mark, id){
      let that= this

      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
      }
      that.$store.dispatch('saveUserBehavior', info).then(() => {
      })

    },
  },
  activated() {
    let that = this
    setTimeout(function () {
      that.$refs.child.getClear();
      that.$loginPd()
    }, 500)
  }

}
</script>
<style lang="less" scoped>
#AqtIndex {
  width: 100%;
  height: 100%;
  display: flex;
  background: #ffffff;
  overflow-x: auto;
  justify-content: space-between;

  .left {
    //width: 35%;
    width: 40%;
    //width: 25%;
    height: 100%;
    display: flex;
    align-items: center;
    //justify-content: flex-end;
    justify-content: flex-end;

    img {
      width: 70%;
      height: auto;
    }
  }

  .right {
    width: 50%;
    height: 100%;
    padding: 8% 2%;
    //padding-right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .specialcolumn {
    //max-width: 40%;
    width: 10%;
    padding: 9% 0;
    display: -webkit-box;
    padding-left: 10px;
    overflow-x: auto;

    .column_list {
      width: 83px;
      height: 100%;
      //opacity: 0.7;
      border-radius: 10px;
      margin-right: 23px;
      font-size: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background-size: 100% 100%;
      background-repeat: no-repeat;

    }

    .column_list:hover {
      //opacity: 0.37;
      opacity: 0.5;
    }

    .column_list_img {
      width: 83px;
      height: 100%;
      border-radius: 10px;
      margin-right: 23px;
      cursor: pointer;
      padding: 1px;
      img{
        width: 83px;
        height: 100%;
      }
    }
    .column_list_img:hover {
      opacity: 0.37;
    }
  }
}
</style>
